import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Box, HStack, Spinner, VStack } from "native-base";
import CryptoJS from "crypto-js";
import Wallet from "../../../../containers/wallet";
import { getQuickLinkWalletAPI } from "../../../../api/apis/quicklinks";
import { Toaster } from "../../../../components/toaster";
import { eventDetailsAPI, eventListingAPI } from "../../../../api/apis/event";
import { getWorkflowAPI } from "../../../../api/apis/workflow";
import NoDataFound from "../../../../components/noDataFound";
import { useSelector } from "react-redux";
import CustomButton from "../../../../components/button";
import { COLORS } from "../../../../utils/colors";
import config from "../../../../utils/config";

const WalletListing = forwardRef((props, ref) => {
  const { scrollToTop = () => {} } = props;
  const toaster = Toaster();
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem("content"),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  const [walletDetails, setWalletDetails] = useState([]);
  const activeTab = useSelector((state) => {
    return state.event.activeTab;
  });
  const [visibleItems, setVisibleItems] = useState(12);
  const [isLoading, setIsLoading] = useState(true);

  const showMore = () => {
    setVisibleItems((prevVisibleItems) => prevVisibleItems + 12);
  };

  useEffect(() => {
    setIsLoading(true);
    setWalletDetails([]);
    getWalletListing();
    // props.setWalletData(false);
  }, [activeTab, props.selectedOption]);

  const getEventName = async (id) => {
    let res = await eventDetailsAPI(id);
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      return res.data.data.data.event_name;
    }
  };

  const getWalletListing = async () => {
    let tab = props.selectedOption.includes("_")
      ? activeTab === "event"
        ? "general_event"
        : activeTab === "mice" && "general_mice"
      : props.selectedOption;
    let res = await getQuickLinkWalletAPI(userInfo.email, tab);
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      let wallet = [];
      if (res?.data?.data?.data?.length > 0) {
        props.setWalletData(true);
      } else if (
        (props.selectedOption.includes("_") || props.selectedOption === "") &&
        (res?.data?.data?.data?.length === 0 || !res?.data?.data?.data)
      )
        props.setWalletData(false);
      if (res?.data?.data?.data)
        for (const item of res?.data?.data?.data) {
          if (item.boarding_pass && item.boarding_pass[0]) {
            item.boarding_pass.map((val) => {
              wallet.push({
                type: val.doc_type?.split(".").pop(),
                file_name: val?.file_name,
                document_name: val.doc_type,
                uploaded_time: val.uploaded_time,
                file_size: val.file_size,
                category: "",
                event_id: item.event_name,
                wallet_id: item._id,
                added_by: item.added_by,
              });
            });
          } else {
            wallet.push({
              type: item.documents[0].doc_type?.split(".").pop(),
              file_name: item.documents[0]?.file_name,
              document_name: item.document_name,
              uploaded_time: item.documents[0].uploaded_time,
              file_size: item.documents[0].file_size,
              category: item.type,
              event_id: item.event_id ? await getEventName(item.event_id) : "",
              wallet_id: item._id,
              added_by: item.added_by,
            });
          }
        }
      setWalletDetails(wallet);
    }
    setIsLoading(false);
  };

  useImperativeHandle(ref, () => ({
    getWalletListing,
  }));

  return (
    <>
      {isLoading ? (
        <Box mt={10} flex={1} alignItems="center" justifyContent="center">
          <Spinner color={COLORS.THEME_COLOR} size="lg" />
        </Box>
      ) : (
        <VStack space={2}>
          <HStack
            mt={3}
            flex={1}
            flexWrap={"wrap"}
            w={"100%"}
            space={5}
            // justifyContent={"center"}
          >
            {walletDetails.length > 0 ? (
              walletDetails?.slice(0, visibleItems).map((item) => {
                return <Wallet walletDetails={item} activeTab={activeTab} onWalletDelete={getWalletListing} scrollToTop={scrollToTop} addedBy={item.added_by} />;
              })
            ) : (
              <Box justifyContent={"center"} w={"100%"}>
                <NoDataFound dataName="document" />
              </Box>
            )}
          </HStack>
          {walletDetails.length > 0 && visibleItems < walletDetails.length && (
            <Box alignItems={"center"}>
              <CustomButton
                // isOutline
                text="View More"
                // textColor={COLORS.BLACK_COLOR}
                // bgColor={COLORS.BLACK_COLOR}
                borderRadius="50px"
                width="fit-content"
                py={3}
                onPress={showMore}
              />
            </Box>
          )}
        </VStack>
      )}
    </>
  );
});

export default WalletListing;
